/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CourseDetail {
  active?: boolean;
  activeContents?: number;
  activeModules?: number;
  author?: string;
  businessUnitId?: number;
  contents?: number;
  courseId?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  description?: string;
  image?: string;
  length?: number;
  likes?: number;
  link?: string;
  modules?: number;
  name?: string;
  subtitle?: string;
}
